module.exports = __webpack_public_path__ + "media/icons/twitter-black-894666a9.png";